export const FETCH_PENDING_VISITS = "[RECEPTIONIST] FETCH_PENDING_VISITS";
export const FETCH_PENDING_VISITS_START = "[RECEPTIONIST] FETCH_PENDING_VISITS_START";
export const FETCH_PENDING_VISITS_SUCCESS = "[RECEPTIONIST] FETCH_PENDING_VISITS_SUCCESS";
export const FETCH_PENDING_VISITS_ERROR = "[RECEPTIONIST] FETCH_PENDING_VISITS_ERROR";
export const SET_PENDING_VISITORS_PAGINATION = "SET_PENDING_VISITORS_PAGINATION";


export const fetchVisitsRoasterPending = (data) => {
    return {
        type: FETCH_PENDING_VISITS,
        payload: data
    }
}